/**
 * Set campaignMarker cookie based on url parameters
 * @version 1.0.0
 * @author Erik Ondrus <erik.ondrus@avast.com>
 * @requires avast.storage.cookieStorage
 * @requires avast.web.campaignMarkerDecorator for decorating links
 */

(function() {
	'use strict';

	var listCM = {
		'AFF-CJ': ['utm_medium=affiliate', 'utm_source=commissionjunction'],
		'S-FB': ['utm_medium=cpc&utm_source=facebook'],
		'S-LN': ['utm_medium=cpc&utm_source=linkedin'],
		'PPC-SKLIK': ['utm_medium=ppc&utm_source=sklik'],
		DISPLAY: ['utm_source=all', 'utm_medium=display'],
		PPC: ['gclsrc=aw.ds'],
		"Display-MiQ": ["utm_source=miq&utm_medium=cpc&utm_campaign"],
  		"Display-CBSi-Prosp": ["utm_source=cbs&utm_medium=cpc&utm_campaign"]
	};

	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		locationHref = window.location.href,
		expirationInMinutes = 30,
		campaignMarker,
		CAMPAIGN_MARKER = 'campaignMarker',
		MARKER_WEB = 'SMBW',
		MARKER_LP = 'SMBLP';

	/*
	 * @param {object} - list of CMs {'marker': ['parameter=value']}
	 * @param {string} - window.location.Href
	 * @returns {string}
	 */
	var getMarkerBasedOnList = function(listOfCm, locationHref) {
		var marker = Object.keys(listOfCm).filter(function(key) {
			return listOfCm[key].every(function(item) {
				return locationHref.indexOf(item) > -1;
			});
		});
		return marker.join('-');
	};

	/*
	 * @param {string} - window.location.Href
	 * @returns {string}
	 */
	var getPageTypeMarker = function(locationHref) {
		return locationHref.indexOf('/lp-') > -1 ? MARKER_LP : MARKER_WEB;
	};

	/*
	 * @param {object} - list of CMs {'marker': ['parameter=value']}
	 * @param {string} - window.location.Href
	 * @returns {string}
	 */
	var getCampaignMarker = function(listOfCm, locationHref) {
		var pageMarker = getPageTypeMarker(locationHref);
		var marker = getMarkerBasedOnList(listOfCm, locationHref);
		return marker && pageMarker + '-' + marker;
	};

	/*
	 * @param {number} - minutes
	 * @returns {UTCString}
	 */
	var getExpirationTime = function(minutes) {
		var now = new Date();
		now.setTime(now.getTime() + minutes * 60 * 1000);
		return now.toUTCString();
	};

	/*
	 * Set Cookie with campaignMarker
	 */
	campaignMarker = getMarkerBasedOnList(listCM, locationHref); // PageTypeMarker disabled
	if (campaignMarker && campaignMarker.length > 0) {
		cookieStorage.setItem(CAMPAIGN_MARKER, campaignMarker, getExpirationTime(expirationInMinutes), '/', location.hostname, false);
	}
})();
